module.exports = __webpack_public_path__ + "static/media/quindio-70.40bc0c45.jpg";